import EntityBase from './EntityBase';

import { immerable } from 'immer';

export default class EntityState extends EntityBase() {
  [immerable] = true;
}
